module.exports = __webpack_public_path__ + "static/media/mm.361afba5.svg";